import { h } from '@atomify/jsx';
import { inviewObserver } from '@source/utilities/inview';

interface LazyRenderInterface {
    renderFunction: () => Element;
    classes?: string;
    threshold?: number;
}

const RENDERED_CLASS = 'is--rendered';

const LazyRender = ({ renderFunction, classes = '', threshold = 0.5 }: LazyRenderInterface) => {
    let isRendered = false;

    const element = (<div class={classes}></div>) as Element;

    inviewObserver.observe(
        element,
        inView => {
            if (inView && !isRendered) {
                element.append(renderFunction());
                element.classList.add(RENDERED_CLASS);
                isRendered = true;
                inviewObserver.unobserve(element);
            }
        },
        {
            threshold,
        },
    );

    return element;
};

export default LazyRender;
